import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    display: "block",
    fontSize: "30px",
    textAlign: "center",
    textTransform: "uppercase",
    marginBottom: "20px",
    ['@media (max-width: 992px)']: {
      fontSize: "26px",
      lineHeight: "30px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "20px",
      lineHeight: "26px",
      textAlign: "left"
    },
  },
}));

const BlockHeader = (props) => {
  const classes = blockStyles();
  const { className, children } = props;
  return (
    <span className = { clsx(classes.root, className) } >
      { children }
    </span>
  );
};

export default BlockHeader;